<template>
  <div>
    <div class="label">
      <span>Legenda</span>
      <span class="has-text-weight-normal"><font-awesome-icon icon="circle" class="status-closed-bg mr-1 ml-3" />Concluso</span>
      <span class="has-text-weight-normal" v-if="!hideCancelled"><font-awesome-icon icon="circle" class="status-cancel-bg mr-1 ml-3" />Annullato</span>
      <span class="has-text-weight-normal"><font-awesome-icon icon="circle" class="status-waiting-bg mr-1 ml-3" />Da completare</span>
    </div>

    <div class="onlyPrint" v-if="$refs.vuecal?.view?.id === 'day'">
      <div class="is-flex is-align-items-center is-justify-content-space-between">
        <div>
          {{ activeDate.toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })  }}
        </div>
        <div>
          <strong>{{ this.$fullname(operator) }}</strong>
        </div>
      </div>
    </div>

    <div oncontextmenu="return false;">
      <vue-cal
        ref="vuecal"
        class="vuecal--blue-theme"
        :active-view="activeView"
        :time="true"
        :time-from="8 * 60"
        :time-to="19 * 60"
        :time-step="30"
        :show-time-in-cells="true"
        :show-week-numbers="true"
        :hide-weekdays="[7]"
        :disable-views="['years', 'year']"
        locale="it"
        :events="events"
        events-on-month-view="short"
        :snap-to-time="30"
        :splitDays="splitDays"
        sticky-split-labels
        :min-split-width="110"
        :editable-events="{ title: false, drag: canEdit, resize: canEdit, delete: false, create: canCreate }"
        :selected-date="activeDate"
        @event-drop="onEventDrop"
        @event-click="onEventClick"
        @event-duration-change="onEventDurationChange"
        @event-drag-create="onEventDragCreate"
        @ready="onCalendarReady()"
        @view-change="onViewChange"
      >
        <template #split-label="{ split, view }">
          <strong class="noPrint" :style="`color: ${split.color}`">{{ split.label }}</strong>
        </template>

        <template #weekday-heading="{ heading, view }">
          <div class="week-day-cell" :class="{selected: heading.today}" v-if="view.id === 'week'">
            {{ heading.label + ' ' + heading?.date?.getDate() }}
          </div>
        </template>

        <template #title="{ title, view }">
          <span v-if="view.id === 'week'">{{ view.startDate.getDate() }} {{ view.startDate.toLocaleDateString(undefined, { month: 'long' }).capitalize() }} {{ view.startDate.getFullYear() }} - {{ view.endDate.getDate() }} {{ view.endDate.toLocaleDateString(undefined, { month: 'long' }).capitalize() }} {{ view.endDate.getFullYear() }}</span>
        </template>
      </vue-cal>

      <div class="dropdown-menu" id="dropdown-menu" role="menu" :style="{display: context.visible ? 'block' : 'none', top: context.top, left: context.left}">
        <div class="dropdown-content">
          <a href="javascript:void(0)" @click="deleteEvent()" class="dropdown-item">
            <font-awesome-icon icon="trash-can" /> Elimina
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//https://antoniandre.github.io/vue-cal/
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'

export default {
  components: { VueCal },
  
  props: {
    operator: {
      type: Object
    },
    forceUpdate: {
      type: Boolean
    },
    canCreate: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: true
    },
    activeView: {
      type: String,
      default: 'week'
    },
    activeDate: {
      type: Date,
      default: new Date()
    },
    hideCancelled: {
      type: Boolean,
      default: false
    }
  },

  emits: ['newAppointment', 'refresh', 'onForceUpdate', 'viewChange', 'ready'],

  data() {
    return {
      appointments: [],

      context: {
        visible: false,
        top: '',
        left: '',
        selected: null
      }
    }
  },

  computed: {
    events() {
      let result = []

      this.appointments.forEach(appointment => {
        if (appointment.appointment_date && appointment.appointment_start && appointment.appointment_end) {
          if (appointment.operators) {
            appointment.operators.forEach(operator => {
              if (!this.operator || this.operator._id === operator._id) {
                let addClass = ''
                if (appointment.status === 'Concluso') {
                  addClass = ' status-closed'
                } else if (appointment.status === 'Annullato') {
                  addClass = ' status-cancel'
                } else if (appointment.status === 'Da completare') {
                  addClass = ' status-waiting'
                }

                if (appointment.special) {
                  addClass += ' status-special'
                }
                if (appointment.special2) {
                  addClass += ' status-special-2'
                }

                let telephoneHtml = ''
                if (appointment.occupant && appointment.occupant.contacts && appointment.occupant.contacts[0] && appointment.occupant.contacts[0].telephone) {
                  telephoneHtml = '<span class="onlyPrint inline"> (' + appointment.occupant.contacts[0].telephone +')</span>';
                } else if (appointment.client && appointment.client.contacts && appointment.client.contacts[0] && appointment.client.contacts[0].telephone) {
                  telephoneHtml = '<span class="onlyPrint inline"> (' + appointment.client.contacts[0].telephone +')</span>';
                }

                let contentHtml = '<div>' + appointment.place.city + '<span class="onlyPrint inline">, ' + this.$fulladdress(appointment.place) +'</span></div>'

                contentHtml += '<div>' + (appointment.occupant ? this.$clientName(appointment.occupant) : this.$clientName(appointment.client)) + telephoneHtml + '</div>'

                contentHtml += '<div>' + appointment.type + '</div>'

                contentHtml += '<div>' + this.$implantName(appointment.implant) + '</div>'

                result.push({
                  id: appointment._id,
                  start: appointment.appointment_date + ' ' + appointment.appointment_start,
                  end: appointment.appointment_date + ' ' + appointment.appointment_end,
                  //title: appointment.type,
                  content: contentHtml,
                  class: operator.color + '-card' + addClass,
                  split: operator._id,
                  startDate: '',
                  //background: true
                })
              }
            })
          }
          
        }
      })

      return result
    },

    splitDays() {
      let result = []

      this.$store.getters.operators.forEach(operator => {
        if (!this.operator || this.operator._id === operator._id) {
          result.push({
            id: operator._id,
            class: operator.color,
            label: this.$fullname(operator)
          })
        }
      })

      return result
    }
  },

  methods: {
    getOperations(newAppointment) {
      const self = this

      //this.loading = true

      const startDate = this.$refs.vuecal.view.startDate
      startDate.removeDays(7).toDateInputValue()

      const endDate = this.$refs.vuecal.view.endDate
      endDate.addDays(7).toDateInputValue()

      this.$http.get('/operation', { params: {size: -1, startDate, endDate, excludeCancelled: this.hideCancelled} }).then(response => {
        if (response && response.data) {
          self.appointments = response.data.records
          self.pagination = {
            total: response.data.totalRecords,
            pages: response.data.totalPages,
            selected: response.data.currentPage
          }

          self.$emit('refresh', self.filterAppointments())

          if (newAppointment) {
            self.appointments.push(newAppointment)
          }
        }

        //self.loading = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        //self.loading = false
      })
    },

    onEventClick(event, e) {
      //on left click
      if (!this.canCreate && (e.button === 0 || e.type === 'touchend')) {
        this.$router.push('/appuntamenti/' + event.id)
      } 
      // on right click
      else if (e.button === 2) {
        this.context.visible = true
        this.context.top = e.pageY + 'px'
        this.context.left = e.clientX + 'px'
        this.context.selected = event
      }
    },
    onEventDrop(args) {
      this.updateEvent(args.event)
    },
    onEventDurationChange(args) {
      this.updateEvent(args.event)
    },

    updateEvent(event) {
      const self = this

      const hoursStart = ('0'+event.start.getHours()).slice(-2)
      const minutesStart = ('0'+event.start.getMinutes()).slice(-2)

      const hoursEnd = ('0'+event.end.getHours()).slice(-2)
      const minutesEnd = ('0'+event.end.getMinutes()).slice(-2)

      const newDate = event.start.toDateInputValue()
      const newStart = hoursStart + ':' + minutesStart
      const newEnd = hoursEnd + ':' + minutesEnd

      this.$http.put('/operation/' + event.id, {
        appointment_date: newDate,
        appointment_start: newStart,
        appointment_end: newEnd
      })
        .then(function (response) {
          self.$emit('refresh')
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
        })
    },

    onEventDragCreate(event) {
      const operator = this.$store.getters.operators.find(op => op._id === event.split)

      const newAppointment = {
        appointment_date: event.start.toDateInputValue(),
        appointment_start: event.start.toDateTimeInput(),
        appointment_end: event.end.toDateTimeInput(),
        operators: [operator]
      }

      this.$emit('newAppointment', newAppointment)

      this.getOperations(newAppointment)
    },

    filterAppointments() {
      const startDate = this.$refs.vuecal.view.startDate
      const endDate = this.$refs.vuecal.view.endDate

      let filteredAppointments = this.appointments.filter(ap => 
          new Date(ap.appointment_date).getTime() >= startDate.getTime() && 
          new Date(ap.appointment_date).getTime() <= endDate.getTime()
      )

      if (this.operator) {
        filteredAppointments = filteredAppointments.filter(ap => ap.operators.find(op => this.operator._id === op._id))
      }

      return filteredAppointments
    },

    deleteEvent() {
      const self = this

      this.$http.delete('/operation/' + this.context.selected.id)
        .then(function (response) {
          self.getOperations()
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
        })
    },

    onViewChange(args) {
      this.$emit('viewChange', args)
      this.getOperations()
    },

    onCalendarReady() {
      this.getOperations()
      this.$emit('ready')
    }
  },

  watch: {
    operator() {
      this.$emit('refresh', this.filterAppointments())
    },
    forceUpdate(value) {
      if (value) {
        this.getOperations()
        this.$emit('onForceUpdate')
      }
    }
  },

  created() {
    window.addEventListener('click', (e) => {
      this.context.visible = false
    })
  },
}
</script>

<style lang="scss">
@import "../variables.scss";
//.vuecal__now-line {color: #06c;}
.vuecal {
  height: 100vh;

  .vuecal__bg {
    overflow-x: auto;
  }
}
.status-closed-bg {
  color: $status-closed;
}
.status-cancel-bg {
  color: $status-cancel;
}
.status-waiting-bg {
  color: $status-waiting;
}
.vuecal--week-view {
  .vuecal__flex.vuecal__weekdays-headings {
    padding-right: 0;

    .week-day-cell {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background-color: #64b6ff33;
      border-right: 1px solid #61a9e0;

      &.selected {
        background-color: #badaf7;
      }
    }

    .vuecal__heading:last-child .week-day-cell {
      border-right: none;
    }
  }

  .vuecal__flex {
    .vuecal__cell:not(:last-child) {
      .vuecal__cell-content:last-child {
        border-right: 1px solid #61a9e0;
      }
      
    }
    .vuecal__heading:not(:last-child) {
      .day-split-header:last-child {
        border-right: 1px solid #61a9e0;
      }
    }
  }
}

.vuecal__event {
  &:hover {
    height: fit-content !important;
    z-index: 10;
  }
}
</style>